@if (!editMode) {
  <div class="properties-container">
    <pre [innerHTML]="prettyJson" class="inner-html-element"></pre>
  </div>
}
